import NProgress from 'nprogress'
function injectCSS(color) {
  const element = document.createElement('style')
  element.type = 'text/css'
  element.textContent = `
    #nprogress {
      pointer-events: none;
    }

    #nprogress .bar {
      background: linear-gradient(to right, #6366f1, #8b5cf6, #ec4899);
      box-shadow: 0 0 12px rgba(139, 92, 246, 0.8), 0 0 6px rgba(99, 102, 241, 0.5);

      position: fixed;
      z-index: 10319;
      top: 0;
      left: 0;

      width: 100%;
      height: 3.5px;
    }

    #nprogress .peg {
      display: block;
      position: absolute;
      right: 0px;
      width: 100px;
      height: 100%;
      box-shadow: 0 0 12px #8b5cf6, 0 0 6px #ec4899;
      opacity: 1.0;

      -webkit-transform: rotate(3deg) translate(0px, -4px);
          -ms-transform: rotate(3deg) translate(0px, -4px);
              transform: rotate(3deg) translate(0px, -4px);
    }

    #nprogress .spinner {
      display: block;
      position: fixed;
      z-index: 1031;
      top: 15px;
      right: 15px;
    }

    #nprogress .spinner-icon {
      width: 18px;
      height: 18px;
      box-sizing: border-box;

      border: solid 2px transparent;
      border-top-color: ${color};
      border-left-color: ${color};
      border-radius: 50%;

      -webkit-animation: nprogress-spinner 400ms linear infinite;
              animation: nprogress-spinner 400ms linear infinite;
    }

    .nprogress-custom-parent {
      overflow: hidden;
      position: relative;
    }

    .nprogress-custom-parent #nprogress .spinner,
    .nprogress-custom-parent #nprogress .bar {
      position: absolute;
    }

    @-webkit-keyframes nprogress-spinner {
      0%   { -webkit-transform: rotate(0deg); }
      100% { -webkit-transform: rotate(360deg); }
    }
    @keyframes nprogress-spinner {
      0%   { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `
  document.head.appendChild(element)
}

const Progress = {
  init({ color = '#29d', includeCSS = true, showSpinner = false } = {}) {
    NProgress.configure({ showSpinner })
    if (includeCSS) {
      injectCSS(color)
    }
  },
}
export default Progress
